import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/utils/request'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  mutations: {
    setUserInfo (state, user) {
      state.userInfo = user
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      return request('/auth/getInfo').then((res) => {
        commit('setUserInfo', res.data)
      })
    }
  }
})
